module.exports = __webpack_public_path__ + "static/media/html.5521f70d.pdf";